package pl.finn.forms.fk02

import kotlin.math.round

class NumberToWordAmountConverter {

  companion object {
    fun convertAmountFromNumberToWord(kwota: String): String {
      var slownie = ""
      var kwotaBezSpacji = kwota.replace(" ", "")
      var przecinek = kwotaBezSpacji.indexOfFirst { it == '.' }
      if (przecinek > 0 && (przecinek + 2 == kwotaBezSpacji.length)) {
        kwotaBezSpacji += '0'
      }//poprawka jezeli jest 1 cyfra po przecinku
      var czescCalkowita = if (przecinek > 0) przecinek else kwotaBezSpacji.length
      var temp1: Double = (czescCalkowita / 3.0)
      var liczbaGrup = if (round(temp1) == temp1) temp1.toInt() else (temp1 - temp1 % 1).toInt() + 1
      if (liczbaGrup > 6) { return slownie }
      if (czescCalkowita <= 1 && kwotaBezSpacji.substring(0, czescCalkowita).toLong() == 0L) {
        slownie += "zero złotych "
      } else {
        var grupy = mutableMapOf<Int, String>()
        grupy.put(liczbaGrup, kwotaBezSpacji.substring(0, (czescCalkowita - 3 * (liczbaGrup - 1))))
        if (liczbaGrup > 1) {
          for (i in 1 until liczbaGrup) {
            grupy.put(i, kwotaBezSpacji.substring(czescCalkowita - 3 * i, czescCalkowita - 3 * (i - 1)))
          }
        }
        for (i in 0 until liczbaGrup) {
          grupy.get(liczbaGrup - i)?.let {
            slownie += grupaSlownie(it)
            slownie += nazwaGrupySlownie(it, liczbaGrup - i)
          }
        }
        slownie += grupy.get(1)?.let { zlote(it) }
      }
      if (przecinek > 0 && kwotaBezSpacji.length > przecinek) {
        slownie += grupaSlownie(kwotaBezSpacji.substring(przecinek + 1, kwotaBezSpacji.length))
        slownie += grosze(kwotaBezSpacji.substring(przecinek + 1, kwotaBezSpacji.length))
      }
      return slownie
    }

    private fun grupaSlownie(grupa: String): String {
      var slownie = ""
      val wartosc = grupa.toInt()
      if (wartosc >= 100) {
        when (wartosc - wartosc % 100) {
          0 -> {}
          100 -> {
            slownie += "sto "
          }
          200 -> {
            slownie += "dwieście "
          }
          300 -> {
            slownie += "trzysta "
          }
          400 -> {
            slownie += "czterysta "
          }
          500 -> {
            slownie += "pięćset "
          }
          600 -> {
            slownie += "sześćset "
          }
          700 -> {
            slownie += "siedemset "
          }
          800 -> {
            slownie += "osiemset "
          }
          900 -> {
            slownie += "dziewięćset "
          }
        }
      }
      if (grupa.toInt() >= 10) {
        when (wartosc % 100 - wartosc % 10) {
          0 -> {}
          10 -> {}
          20 -> {
            slownie += "dwadzieścia "
          }
          30 -> {
            slownie += "trzydzieści "
          }
          40 -> {
            slownie += "czterdzieści "
          }
          50 -> {
            slownie += "pięćdziesiąt "
          }
          60 -> {
            slownie += "sześćdziesiąt "
          }
          70 -> {
            slownie += "siedemdziesiąt "
          }
          80 -> {
            slownie += "osiemdziesiąt "
          }
          90 -> {
            slownie += "dziewięćdziesiąt "
          }
        }
      }
      if (grupa.toInt() >= 1) {
        if ((wartosc % 100 - wartosc % 10) == 10) {
          when (wartosc % 10) {
            0 -> {
              slownie += "dziesięć "
            }
            1 -> {
              slownie += "jedenaście "
            }
            2 -> {
              slownie += "dwanaście "
            }
            3 -> {
              slownie += "trzynaście "
            }
            4 -> {
              slownie += "czternaście "
            }
            5 -> {
              slownie += "piętnaście "
            }
            6 -> {
              slownie += "szesnaście "
            }
            7 -> {
              slownie += "siedemnaście "
            }
            8 -> {
              slownie += "osiemnaście "
            }
            9 -> {
              slownie += "dziewiętnaście "
            }
          }
        } else {
          when (wartosc % 10) {
            0 -> {}
            1 -> {
              slownie += "jeden "
            }
            2 -> {
              slownie += "dwa "
            }
            3 -> {
              slownie += "trzy "
            }
            4 -> {
              slownie += "cztery "
            }
            5 -> {
              slownie += "pięć "
            }
            6 -> {
              slownie += "sześć "
            }
            7 -> {
              slownie += "siedem "
            }
            8 -> {
              slownie += "osiem "
            }
            9 -> {
              slownie += "dziewięć "
            }
          }
        }
      }
      return slownie
    }

    private fun nazwaGrupySlownie(grupa: String, numerGrupy: Int): String {
      var slownie = ""
      when (numerGrupy) {
        2 -> {
          when (grupa.toInt() % 10) {
            0 -> {
              if (grupa.toInt() > 0) {
                slownie += "tysięcy "
              }
            }
            1 -> {
              if (grupa.toInt() > 1) {
                slownie += "tysięcy "
              } else {
                slownie += "tysiąc "
              }
            }
            2, 3, 4 -> {
              if ((grupa.toInt() % 100 - grupa.toInt() % 10) == 10) {
                slownie += "tysięcy "
              } else {
                slownie += "tysiące "
              }
            }
            else -> {
              slownie += "tysięcy "
            }
          }
        }
        3 -> {
          when (grupa.toInt() % 10) {
            0 -> {
              if (grupa.toInt() > 0) {
                slownie += "milionów "
              }
            }
            1 -> {
              if (grupa.toInt() > 1) {
                slownie += "milionów "
              } else {
                slownie += "milion "
              }
            }
            2, 3, 4 -> {
              if ((grupa.toInt() % 100 - grupa.toInt() % 10) == 10) {
                slownie += "milionów "
              } else {
                slownie += "miliony "
              }
            }
            else -> {
              slownie += "milionów "
            }
          }
        }
        4 -> {
          when (grupa.toInt()) {
            0 -> {
              if (grupa.toInt() > 0) {
                slownie += "miliardów "
              }
            }
            1 -> {
              if (grupa.toInt() > 1) {
                slownie += "miliardów "
              } else {
                slownie += "miliard "
              }
            }
            2, 3, 4 -> {
              if ((grupa.toInt() % 100 - grupa.toInt() % 10) == 10) {
                slownie += "miliardów "
              } else {
                slownie += "miliardy "
              }
            }
            else -> {
              slownie += "miliardów "
            }
          }
        }
        5 -> {
          when (grupa.toInt()) {
            0 -> {
              if (grupa.toInt() > 0) {
                slownie += "bilionów "
              }
            }
            1 -> {
              if (grupa.toInt() > 1) {
                slownie += "bilionów "
              } else {
                slownie += "bilion "
              }
            }
            2, 3, 4 -> {
              if ((grupa.toInt() % 100 - grupa.toInt() % 10) == 10) {
                slownie += "bilionów "
              } else {
                slownie += "biliony "
              }
            }
            else -> {
              slownie += "bilionów "
            }
          }
        }
        6 -> {
          when (grupa.toInt()) {
            0 -> {
              if (grupa.toInt() > 0) {
                slownie += "biliardów "
              }
            }
            1 -> {
              if (grupa.toInt() > 1) {
                slownie += "biliardów "
              } else {
                slownie += "biliard "
              }
            }
            2, 3, 4 -> {
              if ((grupa.toInt() % 100 - grupa.toInt() % 10) == 10) {
                slownie += "biliardów "
              } else {
                slownie += "biliardy "
              }
            }
            else -> {
              slownie += "biliardów "
            }
          }
        }
      }
      return slownie
    }

    private fun zlote(grupa1: String): String {
      when (grupa1.toInt() % 10) {
        0 -> {
          if (grupa1.toInt() > 0) {
            return "złotych "
          }
        }
        1 -> {
          if (grupa1.toInt() > 1) {
            return "złotych "
          } else {
            return "złoty "
          }
        }
        2, 3, 4 -> {
          if ((grupa1.toInt() % 100 - grupa1.toInt() % 10) == 10) {
            return "złotych "
          } else {
            return "złote "
          }
        }
      }
      return "złotych "
    }

    private fun grosze(grosze: String): String {
      when (grosze.toInt() % 10) {
        0 -> {
          if (grosze.toInt() > 0) {
            return "groszy "
          }
        }
        1 -> {
          if (grosze.toInt() > 1) {
            return "groszy "
          } else {
            return "grosz "
          }
        }
        2, 3, 4 -> {
          if ((grosze.toInt() - grosze.toInt() % 10) == 10) {
            return "groszy "
          } else {
            return "grosze "
          }
        }
        else -> {
          return "groszy "
        }
      }
      return ""
    }
  }
}